import {
  get,
} from '@/utils/request';

const url = 'card-types';

export function index({ store_id }) {
  return get({
    url,
    data: {
      store_id,
    },
  });
}
